import { render, staticRenderFns } from "./amazon.vue?vue&type=template&id=caab0aa6&scoped=true"
import script from "./amazon.vue?vue&type=script&lang=js"
export * from "./amazon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caab0aa6",
  null
  
)

export default component.exports